import React from "react";
import { Button, Col, Row } from "antd";
import { useSelector } from "react-redux";
import {
  defaultSupporterInfoSelector,
  defaultSupporterTypeSelector,
} from "store/user/(default)/supporter/default_supporter.selector";
import { FaQrcode } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { setDefaultSupporterType } from "store/user/(default)/supporter/default_supporter.action";
import SupporterScanTab from "./supporter_scan_tab";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const SupporterScan = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const supporterInfo = useSelector(defaultSupporterInfoSelector);
  const type = useSelector(defaultSupporterTypeSelector);
  const enabled = !supporterInfo && type === "qr";
  // -------------------------- FUNCTION ------------------------

  const handleSwitchQR = () => {
    dispatch(setDefaultSupporterType("email"));
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const QRButton = () => {
    return (
      <Button
        onClick={handleSwitchQR}
        icon={
          <span className="anticon">
            <FaQrcode />
          </span>
        }
        type="link"
      >
        Tìm kiếm email
      </Button>
    );
  };

  const renderQRScan = () => {
    return (
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          <SupporterScanTab />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN ----------------------------
  if (!enabled) return null;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ fontWeight: "bold" }}>Tìm kiếm theo mã QR</span>
        <QRButton />
      </div>
      {renderQRScan()}
    </div>
  );
};
export default SupporterScan;
